module.exports = __webpack_public_path__ + "static/img/docx.f99844af.png";